import React, { useContext, useEffect, useState, useRef } from 'react'
import moment from 'moment'
import { Progressbar, SpinnerDotted } from '../common/atoms'
import { FailModal } from '../modals'
import { checkIfUnique, csvToJson } from '../../utils'
import { EmployeeDataHoc } from '../../utils/hocs'
import { AppDispatchContext, AppStateContext } from '../../utils/contexts'
import { uploadFileSchema as schema } from '../../schemas/validation'
import { EMPLOYEE_PAGE_CONTENT, ALLOWED_RELATION_LIMIT, INIT_RELATIONS } from '../../constants/employeeData'

const FileUpload = ({ history, location }) => {
  const [state, setState] = useState({
    progress: 0,
    modaldata: {},
    modalFlag: false,
  })
  const {
    employee_data: { file, entities },
  } = useContext(AppStateContext)
  const dispatch = useContext(AppDispatchContext)
  const query = new URLSearchParams(location.search).get('of')
  const { [query]: CONTENT } = EMPLOYEE_PAGE_CONTENT
  const timeoutId = useRef()

  const updateProgress = () => {
    const { progress } = state
    if (progress < 90) {
      setState((state) => {
        return { ...state, progress: progress + 10 }
      })
      timeoutId.current = setTimeout(() => updateProgress(), 5)
    }
  }

  const validateDOB = (data) => {
    data.forEach((item) => {
      if (item['date_of_birth'] ?? item['dob']) {
        const date = item['date_of_birth'] || item['dob']
        let arr = date.includes('/') ? date.split('/') : date.split('-'),
          resflag = true
        const flag = arr[0].length === 2 && arr[1].length === 2 && arr[2].length === 4
        if (!(arr.length === 3 && flag && moment(date, 'DD MM YYYY').isSameOrBefore(moment(new Date())))) resflag = false
        if (resflag) resflag = moment(date, 'DD MM YYYY').isValid()

        if (!resflag) {
          const { errors = {} } = item
          let hiligher = "DOB should be in 'dd-mm-yyyy or dd/mm/yyyy' format and valid"
          if(CONTENT['title'] === 'Pre employement bulk checkups'){
            item.errors = { ...errors, dob: hiligher}
          }else{
            item.errors = { ...errors, date_of_birth: hiligher}
          }
        }
      }
    })
  }

  const setRelation = (check, data, email, relation, relation_count) => {
    if (check) data = { ...data, [email]: { count: data[email]['count'], relations: { ...data[email]['relations'], [relation]: relation_count+1 } } }
    return data
  }

  const validateDependents = (data) => {
    const relations = INIT_RELATIONS
    let dependentCheck = {}
    const ALLOWED_RELATIONS = Object.keys(ALLOWED_RELATION_LIMIT)
    data.forEach((item) => {
      let { email = '', relation = '' } = item
      relation = relation.trim().toLowerCase()
      email = email.trim()
      const check = email && dependentCheck[email]
      const init_check = email && !dependentCheck[email]
      const relation_check = ALLOWED_RELATIONS.includes(relation)

      if (init_check) {
        dependentCheck = { ...dependentCheck, [email]: { count: 1, relations: { ...relations } } }
        dependentCheck = setRelation(relation_check, dependentCheck, email, relation, 0)
      } else if (check && dependentCheck[email]['count'] > 7) {
        const { errors = {} } = item
        item.errors = { ...errors, rowerror: 'Dependent limit exceeded' }
      } else if (check && dependentCheck[email]['count'] <= 7) {
        const count = dependentCheck[email]['count']
        const cur_relation_count = dependentCheck[email]['relations'][relation] || 0
        if (relation_check) {
          if (cur_relation_count + 1 > ALLOWED_RELATION_LIMIT[relation]) {
            const { errors = {} } = item
            item.errors = { ...errors, rowerror: `Relation "${relation}" limit exceeded` }
          } else {
            dependentCheck = { ...dependentCheck, [email]: { ...dependentCheck[email], count: count + 1 } }
            dependentCheck = setRelation(relation_check, dependentCheck, email, relation, cur_relation_count)
          }
        } else {
          dependentCheck = { ...dependentCheck, [email]: { ...dependentCheck[email], count: count + 1 } }
          dependentCheck = setRelation(relation_check, dependentCheck, email, relation, cur_relation_count)
        }
      }
    })
  }

  const validateAppointmentDate = (data) => {
    data.forEach((item) => {
      if(item['date_of_appointment']){
        const dateOfApp = moment(item['date_of_appointment'], 'DD-MM-YYYY')
        let resflag = true;
        if(!(dateOfApp > moment(new Date()) && dateOfApp <= moment(new Date()).add(30, 'days'))) resflag = false;

        if (resflag) resflag = moment(dateOfApp, 'DD MM YYYY').isValid()

        if (!resflag) {
          const { errors = {} } = item
          item.errors = { ...errors, date_of_appointment: "Date of appointment is not valid"}
        }
      }
    })

  }

  const validateJoiningDate = (data) => {
    data.forEach((item) => {
      const dateOfJoin = moment(item['date_of_joining'], 'DD-MM-YYYY');
      let resflag = true;
      if(item['date_of_joining']){
        let msg = 'Date of Joining is not a valid';
        if(item['date_of_appointment']) {
          const dateOfApp = moment(item['date_of_appointment'], 'DD-MM-YYYY');
          if((dateOfJoin <= dateOfApp)) {
            resflag = false
            msg = 'Date of Joining should be greater than Date of appointment';
          }
        }else {
          if (dateOfJoin <= moment().add(0, 'day')) {
            resflag = false;
            msg = "Date of Joining should be greater today's date" ;
          }
        }
  
        if(!(moment(dateOfJoin, 'DD MM YYYY').isValid())) {
          resflag = moment(dateOfJoin, 'DD MM YYYY').isValid()
          msg = 'Date of Joining is not a valid';
        }
  
        if(!resflag) {
          const { errors = {} } = item
          item.errors = { ...errors, date_of_joining: msg}
        }
      }
    })
  }

  const setData = (data, headers, err, csvData) => {
    clearTimeout(timeoutId.current)
    if (err) {
      setState((state) => {
        return { ...state, modaldata: { liner: err.title, description: err.description }, modalFlag: true, progress: 100 }
      })
    } else {
      if (CONTENT['title'] === 'Add Employee') checkIfUnique(data, ['employee_code', 'email', 'mobile_number'])
      if (CONTENT['title'] === 'Family Members') validateDependents(data)
      if (CONTENT['title'] === 'Pre employement bulk checkups') {
        checkIfUnique(data, ['aadhar_card', 'email', 'mobile_number'])
        validateAppointmentDate(data);
        validateJoiningDate(data);
      }
      if (CONTENT['title'] === 'Create new teams' || CONTENT['title'] === 'Re-upload teams') checkIfUnique(data, ['email'])
      if (CONTENT['title'] === 'Create new members' || CONTENT['title'] === 'Re-upload members') checkIfUnique(data, ['email'])
      let errorcount = 0
      data.forEach((item) => (errorcount += item.errors ? 1 : 0))
      dispatch({ type: 'employee_data', csvData })
      dispatch({ type: 'employee_data', tabledata: { data, headers, errorcount } })

      setState((state) => {
        return { ...state, progress: 100 }
      })
      timeoutId.current = setTimeout(() => history.push(`/employee-data/view-errors?of=${query}`), 500)
    }
  }

  const closeModal = (event) => {
    dispatch({ type: 'reset_employee_data' })
    if (event.target.innerText === 'Re-Upload File') dispatch({ type: 'toggle dragger click' })
    history.goBack()
  }
  useEffect(() => {
    if (file) csvToJson(file, CONTENT['headers'], schema[query]({ entities }), setData)
    else history.push(CONTENT['breadcrumb']['link'])

    updateProgress()
    return () => clearTimeout(timeoutId.current)
  }, [])

  return (
    <EmployeeDataHoc 
      title={CONTENT['title']} 
      breadcrumb={(CONTENT['title'] === 'Create new teams' || CONTENT['title'] === 'Re-upload teams' || CONTENT['title'] === 'Create new members' || CONTENT['title'] === 'Re-upload members') ?
        [
          { text: 'Engagement', link: '/stepathon' },
          { text: 'Stepathon', link: '/stepathon' },
          CONTENT['breadcrumb']
        ] :
        [
          CONTENT['title'] === 'Pre employement bulk checkups' ? 
          { text: 'Pre employment', link: '/pre-employee-checkup'  } : 
          { text: 'Manage Employees', link: '/employee-registration' },
          CONTENT['breadcrumb']
        ]
      }
      close={() => history.goBack()}
    >
      <Progressbar classes='mt-6' percent={state.progress} heading='We are validating your data' filename={file ? file.name : ''} close={() => history.goBack()} />
      <div className={`mt-40 text-center ${state.modalFlag ? 'hidden' : ''}`}>
        <SpinnerDotted classes='h-14 w-14' />
        <p className='mb-0 mt-4 text-base text-gray-700 font-semibold'>Please wait, validation in process</p>
      </div>
      <FailModal
        visible={state.modalFlag}
        title='File uploading failed'
        description={state.modaldata.description}
        liner={state.modaldata.liner}
        btntext='Re-Upload File'
        close={closeModal}
        btnhandler={closeModal}
      />
    </EmployeeDataHoc>
  )
}

export default FileUpload
